import React from "react";
import NavBar from "../../components/NavBar";
import { GlobalState } from '../../AppContext';
import { useHistory } from "react-router-dom";
import { DateRevivier, Session, Animal } from '../../Types';
import {TagIcon} from '../../components/Icons';


const ActiveInjuriesSummary: React.SFC<{}> = () => {
  let history = useHistory();
  // work out which summary to view
  let toView = Number.parseInt(window.location.hash.substr(1));
  let session: Session = {...GlobalState.state};
  let sessionsJSON = localStorage.getItem("sessions");
  if (sessionsJSON) {
    let tempSessions = JSON.parse(sessionsJSON, DateRevivier ) as Session[];
    let storedSessions: Session[] = [];
    if (!Array.isArray(tempSessions)){
      storedSessions.push(tempSessions);
    } else {
      storedSessions = tempSessions;
    }
    storedSessions.forEach( (stored) =>{
      if(stored.session_id === toView) {
        session = {...stored};
      }
    });
  }
  const herd = session.herd;
  let injured: Animal[] = [];
  session.animals.forEach(animal => {
    if (animal.activeInjury) {
      injured.push(animal);
    }
    
  });

  const homeHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push('/');
  }
  const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.goBack();
  }


  return (
    <>
      <NavBar 
        backBtnTitle="Back"
        backBtnClick={backHandler}
        actionBtnTitle="Home"
        actionBtnClick={homeHandler}
        supTitle="Herd:"
        title={herd}
      />
      <h1>Active Injuries</h1>
      <div className="content-pane">
        <div className="horz-scroll">
        <table>
            <thead>
                <tr>
                  <th className="pan"><TagIcon fill="#FFDD57" className="head-tag" /></th>
                    <th>Tail</th>
                    <th>Injured</th>
                    <th>Docked</th>
                    <th>Mild</th>
                    <th>Severe</th>
                </tr>
            </thead>
            <tbody>
            {injured.map((animal) => {
              let injured = (animal.activeInjury === true) ? 'YES' : '';   
              return <tr key={animal.tagNumber}>
                      <td>{animal.tagNumber}</td>
                      <td>{animal.tailCondition.toUpperCase()}</td>
                      <td>{injured}</td>
                      <td>{animal.dockedPosition.toUpperCase()}</td>
                      <td>{animal.lowMildCount + animal.midMildCount + animal.highMildCount}</td>
                      <td>{animal.lowSevereCount + animal.midSevereCount + animal.highSevereCount}</td>
                </tr>
              })}
            </tbody>
        </table>
        </div>
      </div>
    </>
    )
}


export default ActiveInjuriesSummary;
